import Header from "../../components/Header/Header";
import Cart from "../../components/Cart/Cart";




function UserCart() {
    return (
      <main>
        <Header />
        <Cart />
      </main>
    );
}







export default UserCart;